<template>
  <mijn-overzicht />
</template>

<script>
import MijnOverzicht from '../components/MijnOverzicht.vue'

export default {
  name: 'MijnOverzichtView',
  components: {
    MijnOverzicht
  }
}
</script>
